<template>
  <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="teal darken-2" dense>
        <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
        <v-toolbar-title class="text-body-2">
          Detalle de Remito — OT {{ remito.ot }} ({{ remito.nombre }})
        </v-toolbar-title>
        <v-spacer />
        <v-btn small outlined dark @click="imprimir"><v-icon left small>mdi-printer</v-icon>Imprimir</v-btn>
      </v-toolbar>

      <div v-if="cargando" class="text-center pa-6">
        <v-progress-circular indeterminate color="teal" />
      </div>

      <div v-else ref="printArea">
        <!-- Encabezado -->
        <v-card flat class="pa-4">
          <v-row dense>
            <v-col cols="6" sm="3"><div class="label">OT</div><div class="valor">{{ remito.ot }}</div></v-col>
            <v-col cols="6" sm="3"><div class="label">Nombre OT</div><div class="valor">{{ remito.nombre }}</div></v-col>
            <v-col cols="6" sm="3"><div class="label">Fecha</div><div class="valor">{{ formatFecha(remito.fecha) }}</div></v-col>
            <v-col cols="6" sm="3"><div class="label">Usuario</div><div class="valor">{{ remito.nombreUsu }}</div></v-col>
          </v-row>
          <v-row dense class="mt-2">
            <v-col cols="6" sm="3"><div class="label">Solicitó</div><div class="valor">{{ remito.solicito }}</div></v-col>
            <v-col cols="6" sm="3"><div class="label">Lugar de Entrega</div><div class="valor">{{ remito.lugar }}</div></v-col>
            <v-col cols="6" sm="3"><div class="label">Preparó</div><div class="valor">{{ remito.preparo }}</div></v-col>
            <v-col cols="6" sm="3"><div class="label">Revisó</div><div class="valor">{{ remito.reviso }}</div></v-col>
          </v-row>
          <v-row dense class="mt-2" v-if="remito.observa">
            <v-col cols="12"><div class="label">Observación</div><div class="valor">{{ remito.observa }}</div></v-col>
          </v-row>
        </v-card>

        <v-divider />

        <!-- Items -->
        <v-card flat class="pa-4">
          <div class="font-weight-bold mb-2" style="font-size: 13px;">Items entregados</div>
          <v-simple-table dense>
            <thead>
              <tr>
                <th style="width:50px;">Item</th>
                <th style="width:90px;">Artículo</th>
                <th>Descripción</th>
                <th style="width:70px;" class="text-center">Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, idx) in items" :key="idx">
                <td>{{ it.item }}</td>
                <td>{{ it.articulo }}</td>
                <td>{{ it.descripcion }}</td>
                <td class="text-center font-weight-bold">{{ it.cantidad }}</td>
              </tr>
              <tr v-if="items.length === 0">
                <td colspan="4" class="text-center grey--text">Sin items</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>

        <v-divider />

        <!-- Firma -->
        <v-card flat class="pa-4" v-if="remito.firma">
          <div class="font-weight-bold mb-2" style="font-size: 13px;">Firma de conformidad</div>
          <div style="border: 1px solid #ccc; border-radius: 6px; padding: 8px; display: inline-block; background: #fafafa;">
            <img :src="remito.firma" alt="Firma" style="max-width: 400px; max-height: 150px;" />
          </div>
        </v-card>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Axios from "../../axios-auth";

export default {
  name: "DetalleRemitoTaller",
  props: ["visible", "idreca"],

  data() {
    return {
      cargando: false,
      remito: {},
      items: [],
    };
  },

  computed: {
    show: {
      get() {
        if (this.visible && this.idreca) this.cargar();
        return this.visible;
      },
      set(val) { if (!val) this.$emit("close"); },
    },
  },

  methods: {
    cargar() {
      if (!this.idreca) return;
      this.cargando = true;
      Axios.get("/Ingenieria/DetalleRemitoTaller", { params: { idreca: this.idreca } })
        .then((r) => {
          this.remito = r.data.remito || {};
          this.items = r.data.items || [];
        })
        .catch(() => { this.remito = {}; this.items = []; })
        .finally(() => { this.cargando = false; });
    },

    formatFecha(f) {
      if (!f) return "";
      const d = new Date(f);
      return d.toLocaleDateString("es-AR");
    },

    imprimir() {
      window.print();
    },
  },
};
</script>

<style scoped>
.label { font-size: 9px; text-transform: uppercase; color: #6b82a0; }
.valor { font-size: 13px; font-weight: 600; }
</style>
